import React from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import _ from 'lodash'
const { MonthPicker, RangePicker, WeekPicker } = DatePicker

export default class DatePickerFilter extends React.Component {

  getValue(value) {
    const { field } = this.props
    const format = field.datetimeFormat || 'YYYY-MM-DD HH:mm:ss'
    if (_.compact(value).length < 2) {
      return {
        lte: moment(_.compact(value)[0]).format(format)
      }
    }
    return {
      gte: moment(value[0]).format(format),
      lte: moment(value[1]).format(format)
    }
  }

  onRangeChange = (value) => {
    const { input } = this.props
    input.onChange(this.getValue(value))
  }

  render() {
  
    return <RangePicker allowEmpty={[ true, true ]} showTime onChange={this.onRangeChange} />
  }
}
